import React, { useState, useEffect, useCallback, useMemo } from "react";
import Swal from "sweetalert2";
import { useHistory, useParams } from "react-router";
import {
  Container,
  Grid,
  TextField,
  Button,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import moment from "moment";
import { setpriceAPI } from "./../services/SetPriceService";

const Setting_Edit_Group_Bu = () => {
  let history = useHistory();
  const { _id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [group_name, setGroup_name] = useState("");
  const [bu_name, setBu_name] = useState("");
  const [status, setStatus] = useState(false);
  const [log, setLog] = useState([]);

  useEffect(() => {
    setpriceAPI
      .getGroup_BUById(_id)
      .then((res) => {
        if (res.status == 200) {
          setData({
            group_name: res.message.group_name,
            bu_name: res.message.bu_name,
            status: !!res.message.status,
            log: res.message?.log || [],
          });
          document.title = `Com7 Merchandise - Group BU : ${res.message.group_name}`;
        } else {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${res.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 5000,
          }).then(() => {
            history.push("/settings/group_bu");
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          confirmButtonColor: "#f27474",
          html: `<span class="colorWhite">${error.message}</span>`,
          backdrop: "transparent",
          background: "rgba(0,0,0,.75)",
          customClass: {
            icon: "switch",
          },
          width: "28rem",
          timer: 5000,
        }).then(() => {
          history.push("/settings/group_bu");
        });
      });
    return () => {
      setData(null);
    };
  }, [_id]);

  useEffect(() => {
    if (data) {
      setGroup_name(data.group_name);
      setBu_name(data.bu_name);
      setStatus(!!data.status);
      setLog(data?.log || []);
    } else {
      setGroup_name("");
      setBu_name("");
      setStatus(false);
      setLog([]);
    }
  }, [data]);

  const checkChange = useMemo(
    () =>
      JSON.stringify(data) ==
      JSON.stringify({ group_name, bu_name, status, log }),
    [data, group_name, bu_name, status, log]
  );

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (!_id) return;
      Swal.fire({
        title: "คุณแน่ใจ ?",
        text: `คุณต้องการแก้ไข Group BU : ${group_name}`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#56A834",
        cancelButtonColor: "#d33",
        confirmButtonText: "แน่ใจ",
        cancelButtonText: "ยังก่อน",
      }).then((result) => {
        if (result.isConfirmed) {
          setLoading(true);
          setpriceAPI
            .editGroup_BU({ _id, group_name, bu_name, status })
            .then((res) => {
              if (res.status == 200) {
                Swal.fire({
                  icon: "success",
                  confirmButtonColor: "#6ab23a",
                  html: `<span class="colorWhite">${res.message}</span>`,
                  backdrop: "transparent",
                  background: "rgba(0,0,0,.75)",
                  customClass: {
                    icon: "switchZ",
                  },
                  width: "28rem",
                  timer: 3000,
                }).then((res) => {
                  history.push("/settings/group_bu");
                });
              } else {
                Swal.fire({
                  icon: "error",
                  confirmButtonColor: "#f27474",
                  html: `<span class="colorWhite">${res.message}</span>`,
                  backdrop: "transparent",
                  background: "rgba(0,0,0,.75)",
                  customClass: {
                    icon: "switch",
                  },
                  width: "28rem",
                  timer: 5000,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                confirmButtonColor: "#f27474",
                html: `<span class="colorWhite">${error.message}</span>`,
                backdrop: "transparent",
                background: "rgba(0,0,0,.75)",
                customClass: {
                  icon: "switch",
                },
                width: "28rem",
                timer: 5000,
              });
            })
            .finally(() => {
              setLoading(false);
            });
        }
      });
    },
    [group_name, bu_name, status, _id]
  );

  return (
    <Container
      style={{
        padding: "20px",
        backgroundColor: "#ffffffbd",
        borderRadius: "10px",
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <h3>
            <strong>แก้ไข Group Bu - {data?.group_name}</strong>
          </h3>
        </Grid>
      </Grid>
      <Container style={{ paddingTop: "1.5rem" }}>
        <div className="row">
          <div className="pt-2 col-lg-12">
            <div className="row">
              <div className="mt-4 col-lg-12">
                <TextField
                  style={{ width: "100%" }}
                  value={group_name}
                  onChange={(event) => setGroup_name(event.target.value)}
                  label="ชื่อ Group"
                  disabled={loading}
                />
              </div>
              <div className="mt-4 col-lg-12">
                <TextField
                  style={{ width: "100%" }}
                  value={bu_name}
                  onChange={(event) => setBu_name(event.target.value)}
                  label="ชื่อ Bu"
                  disabled={loading}
                />
              </div>
              <div className="mt-4 col-12">
                <label>
                  <strong>สถานะการใช้งาน</strong>
                </label>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={status}
                        onClick={() => setStatus(true)}
                      />
                    }
                    label="Active"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!status}
                        onClick={() => setStatus(false)}
                      />
                    }
                    label="Disable"
                  />
                </FormGroup>
              </div>
              <div className="mt-4 col-12">
                <Button
                  variant="contained"
                  onClick={onSubmit}
                  disabled={
                    !!loading || !group_name || !bu_name || !!checkChange
                  }
                  style={{
                    border: "2px solid transparent",
                    backgroundColor: "#6ab23a",
                    borderRadius: "5px",
                    color: "white",
                    fontSize: "16px",
                    textDecoration: "none",
                    textTransform: "capitalize",
                  }}
                >
                  Submit
                </Button>
              </div>
              <div className="mt-4 col-12">
                <TableContainer component={Paper} style={{ marginTop: "10px" }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className="table-header-promotion">
                          ครั้งที่
                        </TableCell>
                        <TableCell className="table-header-promotion">
                          รายละเอียด
                        </TableCell>
                        <TableCell className="table-header-promotion">
                          ผู้แก้ไข
                        </TableCell>
                        <TableCell className="table-header-promotion">
                          วันที่แก้ไข
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {log.reverse().map((res, i) => (
                        <TableRow key={res._id} className="table-row-promotion">
                          <TableCell className="table-cell-promotion">
                            {i + 1}
                          </TableCell>
                          <TableCell className="table-cell-promotion">
                            {res.doing}
                          </TableCell>
                          <TableCell className="table-cell-promotion mobile-promotion">
                            {res.username}
                          </TableCell>
                          <TableCell className="table-cell-promotion">
                            {moment(res.created).format("YYYY-MM-DD HH:mm:ss")}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Container>
  );
};

export default Setting_Edit_Group_Bu;
